import { ScheduleStatus } from './schedule/schedule-status.enum';

export class TenantScheduleParameter {
  passThroughOnDispatch: ScheduleStatus[];

  constructor(jsonData?: Partial<TenantScheduleParameter>) {
    if (jsonData) {
      this.passThroughOnDispatch = jsonData.passThroughOnDispatch ?? [];
    }
    this.passThroughOnDispatch ??= [];
  }
}
